export default __webpack_public_path__ + "static/media/icon8.3461b528.png";